import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="components--simple-table"
export default class extends Controller {
  connect() {
  }
}
